import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "text-paragraph" }, " Esta avaliação será analisada, e se for inadequada será removida. ", -1)

import { ref } from "vue";
import type { Rating } from "@phurshell/psiapp-frontend-core/domain";
import { toTypedSchema } from "@vee-validate/zod";
import { useForm } from "vee-validate";
import { useVeeField } from "@/composables/useVeeField";
import { reportRatingSchema } from "@/schemas/profile";
import { EventBus, EventBusNames } from "@/utils/EventBus";
import { toggleModal } from "@/utils/Helper";
import { syncSession } from "@/di/useCases";
import {
  useRatings,
  useRemoveRating,
  useUpdateRating,
} from "@/composables/useRatings";
import AppointmentService from "@/app/services/AppointmentService";
import RatingItem from "./RatingItem.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Ratings',
  setup(__props) {

const { ratings, refetch: refetchRatings } = useRatings();
const { mutateAsync: removeRating } = useRemoveRating();
const { mutateAsync: updateRating } = useUpdateRating();

const submittingIds = ref(new Set<number>());
const currentRating = ref<Rating | null>(null);

const {
  handleSubmit,
  meta,
  resetForm: resetReportForm,
} = useForm({
  validationSchema: toTypedSchema(reportRatingSchema),
  initialValues: { reason_report: "" },
});

const reasonReportModel = useVeeField("reason_report");

function handleReport(rating: Rating) {
  currentRating.value = rating;
  toggleModal("report_rating_modal");
}

const submitting = ref(false);

const handleConfirmReport = handleSubmit(async (values) => {
  try {
    submitting.value = true;
    const params = {
      appointment_id: (currentRating.value as any)?.appointment?.id,
      called_rating_id: currentRating.value?.id,
      reason_report: values.reason_report,
    };
    await new AppointmentService().reviewCallRatings(params);
    EventBus.$emit(EventBusNames.SHOW_TOAST, {
      title: "Avaliação em análise",
      msg: "Nosso time irá analisar o conteúdo da sua avaliação.",
    });
    await refetchRatings();
    resetForm();
  } catch (error) {
    console.error(error);
  } finally {
    submitting.value = false;
  }
});

function resetForm() {
  resetReportForm({ values: { reason_report: "" } });
  toggleModal("report_rating_modal");
}

function onRemove(id: number) {
  EventBus.$emit(EventBusNames.SHOW_CONFIRMATION_ALERT, {
    title: "Deseja remover este depoimento?",
    message:
      "Uma vez que um depoimento for removido, não será possível recupera-lo.",
    confirmationButtonLabel: "Sim, remover",
    cancellationButtonLabel: "Não, voltar",
    confirmCallback: () => handleRemove(id),
  });
}

async function handleRemove(id: number) {
  await removeRating(id);
  EventBus.$emit(EventBusNames.SHOW_TOAST, {
    title: "Depoimento removido",
    msg: "O depoimento foi removido e não está mais visível.",
  });
  await syncSession.execute();
}

async function handleChange(rating: Rating) {
  submittingIds.value = new Set([...submittingIds.value, rating.id]);
  try {
    await updateRating({ id: rating.id, active: !rating.active });
    await syncSession.execute();
  } finally {
    const next = new Set(submittingIds.value);
    next.delete(rating.id);
    submittingIds.value = next;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_TextAreaInput = _resolveComponent("TextAreaInput")!
  const _component_FormButton = _resolveComponent("FormButton")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("template", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ratings), (rating) => {
        return (_openBlock(), _createElementBlock("div", {
          key: rating.id
        }, [
          _createVNode(RatingItem, {
            rating: rating,
            submitting: submittingIds.value.has(rating.id),
            onHandleRemove: _cache[0] || (_cache[0] = (id) => onRemove(id)),
            onHandleChange: _cache[1] || (_cache[1] = (item) => handleChange(item))
          }, null, 8, ["rating", "submitting"])
        ]))
      }), 128))
    ]),
    _createVNode(_component_ModalComponent, {
      title: "Deseja reportar esta avaliação?",
      id: "report_rating_modal",
      backdrop: "false"
    }, {
      body: _withCtx(() => [
        _hoisted_2,
        _createVNode(_component_TextAreaInput, {
          class: "mb-0",
          model: _unref(reasonReportModel),
          placeholder: "Qual motivo deseja reportar?",
          maxLength: 200
        }, null, 8, ["model"])
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_FormButton, {
          color: "danger",
          fullWidth: "",
          loading: submitting.value,
          onOnClick: _unref(handleConfirmReport),
          label: "Reportar",
          disabled: !_unref(meta).valid
        }, null, 8, ["loading", "onOnClick", "disabled"])
      ]),
      _: 1
    })
  ]))
}
}

})